import React, { useEffect, useRef } from 'react'
import { useFormContext, useWatch } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { FormFields } from '~/components/FormFields'
import { FieldComponentProps } from './types'
import { LabelWithInfo } from '../util'

const BANK_ACCOUNT_HOLDER_SLUG = 'bank_account_holder'

const IbanField: React.FC<FieldComponentProps> = ({ field, name, disabled }) => {
  const { control, getValues, trigger } = useFormContext()
  const { t } = useTranslation()

  const self = getValues(name)
  const allFields = (getValues('fields') as any[]) || []
  const bankAccountHolderIndex = allFields.findIndex(
    f => f?.slug === BANK_ACCOUNT_HOLDER_SLUG && f?.category === self?.category && f?.farmerId === self?.farmerId
  )
  const bankAccountHolderValue = bankAccountHolderIndex >= 0 ? `fields[${bankAccountHolderIndex}].value` : undefined

  const ownValue = useWatch({ control, name: `${name}.value` })
  const didMount = useRef(false)
  
  useEffect(() => {
    if (!didMount.current) {
      didMount.current = true
      return
    }
    if (bankAccountHolderValue) trigger(bankAccountHolderValue)
  }, [ownValue])

  const required = !disabled && Boolean(field.fieldRequired)

  const rules = {
    ...(required && {
      required: {
        value: true,
        message: t('Please enter IBAN')
      }
    }),
    validate: (value: string) => {
      if (disabled || value) return true
      const siblingValue = bankAccountHolderValue ? getValues(bankAccountHolderValue) : undefined
      if (siblingValue) {
        return t('Please enter IBAN')
      }
      return true
    }
  }

  return (
    <FormFields.Input
      name={`${name}.value`}
      control={control}
      disabled={disabled}
      label={<LabelWithInfo label={field.label} info={field.info} required={required} />}
      placeholder={field.placeholder || t('Enter iban')}
      rules={rules}
    />
  )
}

export default IbanField
